import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="2wip36tktt20p">
    <p className="font-display text-xl font-semibold italic leading-relaxed text-brand-sageMid md:text-3xl" data-id="element-1" data-mp="28te198rqp1kz">
      🌸 Tu próxima tandada empieza con criterio, no con improvisación.
    </p>
  </div>;
export function App({
  showSocialProofToast = true
}: {
  showSocialProofToast?: boolean;
}) {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'Cosmética Natural — La Guía Definitiva',
      content_type: 'product',
      value: 24990,
      currency: 'ARS'
    });
  }, []);
  return <div className="min-h-screen w-full bg-brand-cream font-display text-brand-text selection:bg-brand-sageMist selection:text-brand-sageDeep" data-id="element-2" data-mp="56mnfkhz7n0">
      <UrgencyBanner data-id="element-3" data-mp="33mf623uvifju" />
      <main data-id="element-4" data-mp="33nq73vwxp979">
        <Hero data-id="element-5" data-mp="33ngfy505kvzz" />
        <PackContents data-id="element-6" data-mp="33mykhalbelt4" />
        <InitialTestimonials data-id="element-7" data-mp="33oi0d0326uud" />
        <PainPoints data-id="element-8" data-mp="38li95irambp6" />
        <LaunchOffer data-id="element-9" data-mp="38l05w267qx7r" />
        <MoreTestimonials data-id="element-10" data-mp="38kgocmkh6au9" />
        <FAQ data-id="element-11" data-mp="3dkuvm2e95gr8" />
        <CostComparison data-id="element-12" data-mp="3dle28mygcipy" />
        <TransitionPhrase data-id="element-13" data-mp="3dlntedv8gvx8" />
        <EmotionalClose data-id="element-14" data-mp="3dm5vvs8ho6dl" />
      </main>
      <Footer data-id="element-15" data-mp="nvssr1axyhud" />
      {showSocialProofToast && <FloatingNotification data-id="element-16" data-mp="nv0z3w0wmu6q" />}
    </div>;
}